/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  EnsureServerReviewRequestBody,
  EnsureServerReviewRequestBody$Outbound,
  EnsureServerReviewRequestBody$outboundSchema,
} from "../components/ensureserverreviewrequestbody.js";

export type EnsureMcpServerReviewSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type EnsureMcpServerReviewRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  ensureServerReviewRequestBody: EnsureServerReviewRequestBody;
};

/** @internal */
export type EnsureMcpServerReviewSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const EnsureMcpServerReviewSecurity$outboundSchema: z.ZodMiniType<
  EnsureMcpServerReviewSecurity$Outbound,
  EnsureMcpServerReviewSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function ensureMcpServerReviewSecurityToJSON(
  ensureMcpServerReviewSecurity: EnsureMcpServerReviewSecurity,
): string {
  return JSON.stringify(
    EnsureMcpServerReviewSecurity$outboundSchema.parse(
      ensureMcpServerReviewSecurity,
    ),
  );
}

/** @internal */
export type EnsureMcpServerReviewRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  EnsureServerReviewRequestBody: EnsureServerReviewRequestBody$Outbound;
};

/** @internal */
export const EnsureMcpServerReviewRequest$outboundSchema: z.ZodMiniType<
  EnsureMcpServerReviewRequest$Outbound,
  EnsureMcpServerReviewRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    ensureServerReviewRequestBody: EnsureServerReviewRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      ensureServerReviewRequestBody: "EnsureServerReviewRequestBody",
    });
  }),
);

export function ensureMcpServerReviewRequestToJSON(
  ensureMcpServerReviewRequest: EnsureMcpServerReviewRequest,
): string {
  return JSON.stringify(
    EnsureMcpServerReviewRequest$outboundSchema.parse(
      ensureMcpServerReviewRequest,
    ),
  );
}
